document.addEventListener(
  'click',
  function (e) {
    const trigger = e.target.closest('#contenidos-trigger');
    if (!trigger) return;

    const isMobile = window.matchMedia('(max-width: 993px)').matches;
    if (!isMobile) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const scope = trigger.closest('header') || document;
    const menuSummary =
      scope.querySelector('header-drawer details > summary.header__icon--menu') ||
      document.querySelector('header-drawer details > summary.header__icon--menu');

    if (!menuSummary) return;
    menuSummary.click();
  },
  true,
);
